import { render } from "./BasePhoneText.vue?vue&type=template&id=3d57faa2&ts=true"
import script from "./BasePhoneText.vue?vue&type=script&lang=ts"
export * from "./BasePhoneText.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__